<template>
<!-- 自定义输入框,很少使用或无使用 -->
    <div data-input-container="entity-input-container" :data-label="label"
         class="define-input-container" ref="defineInput"
         :style="`width:${fixWidth};float:${align};margin:${fixMargin};min-width:${fixMinWidth};`"
         :class="[styleObj,{'disabled':disabled&&inTableStateContrl,'border': !disabled,'inTable':inTable}]"
         >
        <div class="label" v-if="!inTable&&haveLabel" :style="`width:${LabelWidth}`">
            <i :class="`iconfont ${iconfont}`" style="margin-right:5px" v-if="iconfont"></i>
            <span class="span1">{{ label }}</span>
            <span class="required" v-if="required">*</span>
        </div>
        <input :type="insidePattern" class="input" :disabled="disabled" v-model="insideValue"
               :style="`text-align:${fixInputTextAlign}`"
               :maxlength="maxlength" @change="reg" :readonly="!(tableEdit&&edit)" :placeholder="placeholder"
              @keydown.13="changeEditState()"/>
        <div class="icon" v-show="insideValue!=''&&clearable&&!disabled&&tableEdit&&edit&&clearShow">
            <i class="iconfont icon-xiaoyanjing" :class="{'pwd-tri': insidePattern == 'text'}" @click="trigglePattern"
               v-if="pattern=='password'"></i>
            <i class="el-icon-circle-close" @click="clear"></i>
        </div>
    </div>
</template>

<script>
import { judgeRules } from './rules'
export default {
  name: 'defineInput',
  data () {
    return {
      js: 0,
      clearShow: false,
      insideValue: '',
      inTable: false,
      edit: true, // 内部判断是否只读
      inTableStateContrl: true,
      styleObj: {
        error: false,
        'table-error': false
      },
      insidePattern: 'text', // 内部pattern状态
      fixMinWidth: '200px'// 组件最小宽度。
    }
  },
  props: {
    LabelWidth: {
      type: String,
      default: '150px'
    },
    label: {
      type: String,
      default: ''
    },
    iconfont: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    column: {
      type: Number,
      default: 3
    },
    align: {
      type: String,
      default: 'none'
    },
    margin: {
      type: String
      // default: '3px 0.0521rem' //默认input总高度为40+3+3
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: 'text',
      validator: function (value) {
        return ['text', 'password'].includes(value)
      }
    },
    type: {
      type: String,
      default: 'String'
    },
    tableEdit: {
      type: Boolean,
      default: true
    },
    clearable: {
      // 是否可清空
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: -1
    },
    required: {
      // 是否必填
      type: Boolean,
      default: false
    },
    validate: {
      // 验证函数
      type: Function,
      default () {
        return () => true
      }
    },
    placeholder: {
      type: [Number, String],
      default: '--'
    },
    haveLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    fixWidth () {
      return this.inTable ? 'calc(100% - 0.1042rem)' : `calc(${8.33 * this.column}% - 0.1042rem)`
    },
    fixMargin () {
      return this.inTable ? '0' : this.margin
    },
    fixInputTextAlign () {
      return this.inTable ? 'center' : 'left'
    }
  },
  methods: {
    clear () {
      this.insideValue = ''
      this.reg() // 这里貌似没有触发change事件。暂且手动触发
    },
    reg () {
      if (judgeRules(this.required, this.type, this.value, this.validate)) {
        this.inTable ? this.styleObj['table-error'] = false : this.styleObj.error = false
        return true
      }
      this.inTable ? this.styleObj['table-error'] = true : this.styleObj.error = true
      return false
    },
    changeEditState () {},
    trigglePattern () { // 在输入框为密码框类型时，用以切换值是否可见
      this.insidePattern = this.insidePattern === 'text' ? 'password' : 'text'
    }
  },
  watch: {
    insideValue (val) {
      this.$emit('input', val)
    },
    value: {
      handler () {
        this.insideValue = this.value
      }
    }
  },
  created () {
    this.insideValue = this.value
    this.insidePattern = this.pattern
  },
  mounted () {
    try {
      if (this.$refs.defineInput.parentNode.parentNode.nodeName === 'TD') {
        this.inTable = true
        this.edit = false
        this.fixMinWidth = 0
        if (this.disabled) {
          this.inTableStateContrl = false
        }
      }
    } catch (error) {
      console.log('当前组件不存在上两级节点')
    }
  }
}
</script>

<style lang="scss" scoped>
    .define-input-container {
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        height: 40px;
        max-height: 40px;
        // border-radius: 4px;
        box-sizing: border-box;
        margin: 0 0.0521rem;
        position: relative;

        .icon-xiaoyanjing,
        .icon-wenbenkuang {
            position: relative;
            right: 0;
        }

        .icon-xiaoyanjing {
            color: #bdbec8;
        }

        .label {
            min-width: 55px;
            padding: 0 0 0 10px;
            color: #909399;
            font-weight: 700;
            overflow: hidden;
            flex-shrink: 0;
            // float: right;
            // width: 150px;
        }

        .span1 {
            float: right;
            margin-right: 10px;
        }

        .required {
            color: red;
        }

        .input {
            // margin-left: -5px;
            width: 100%;
            padding: 0 10px;
            // flex-grow: 1;
            height: 100%;
            font-size: 14px;
            outline-style: none;
            background-color: transparent;
            color: #707070 ;
            border-radius: 4px;
            border: 1px solid rgba(220, 223, 230, 1);
            font-weight: 700 ;

        }

        input::-webkit-input-placeholder {
            color: #C0C4CC;
        }

        .icon {
            min-width: 35px;
            overflow: hidden;
            display: inline-flex;
            justify-content: flex-end;
            padding: 0 10px;
            position: absolute;
            right: 0;
        }
    }

    .border {
        border: 0;
    }

    .disabled {
        background: rgba(248, 249, 251, 1);
        // border: 1px solid rgba(220, 223, 230, 1);

        .input {
            color: rgba(192, 196, 204, 1);
        }
    }

    .table-edit{

    }

    .error {
        border: 1px solid red;
    }

    .table-error {
        .input {
            color: red;
        }
    }

    .inTable{
        height: 30px;
    }

    .define-input-container:hover {
        .iconxiaoyanjing,
        .iconwenbenkuangshanchu1 {
            display: inline-block;
        }
    }

    .pwd-tri {
        color: #4b4bb3 !important;
    }

    .disabled .input {
        color: #707070
    }
    input:focus{
        border-color: #66afe9;
        outline: 0;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)
    }
</style>
